import { render, staticRenderFns } from "./AccidentVehicleWidget.vue?vue&type=template&id=4d19ba7e&scoped=true&"
import script from "./AccidentVehicleWidget.vue?vue&type=script&lang=js&"
export * from "./AccidentVehicleWidget.vue?vue&type=script&lang=js&"
import style0 from "./AccidentVehicleWidget.vue?vue&type=style&index=0&id=4d19ba7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19ba7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d19ba7e')) {
      api.createRecord('4d19ba7e', component.options)
    } else {
      api.reload('4d19ba7e', component.options)
    }
    module.hot.accept("./AccidentVehicleWidget.vue?vue&type=template&id=4d19ba7e&scoped=true&", function () {
      api.rerender('4d19ba7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/AccidentVehicleWidget.vue"
export default component.exports